import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/sweep/target/_target')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'sweep-targets-list',
        label: 'Sweeps',
        to: '/sweep/target',
      }),
    }) satisfies AggregateBreadcrumb,
});
